export default __webpack_public_path__ + "static/media/Blog4.c86fede3.png";